import React from 'react';
import { Input } from '@gaiads/telia-react-component-library';

import { onWheelDisable } from '../../../utils/ui';

interface PriceVatInputProps {
  priceVat?: string;
  onPriceVatChange: (priceVat: string) => void;
}

export function PriceVatInput(props: PriceVatInputProps) {
  const { priceVat, onPriceVatChange } = props;

  return (
    <>
      {typeof priceVat !== 'undefined' && (
        <Input
          className="daas-product-table__price"
          // @ts-expect-error Type 'number' is not assignable to type  'text' | 'search' | 'email' | 'password' | 'tel' | 'url' | undefined
          type="number"
          showCustomLabel
          name="vat"
          value={priceVat}
          onChange={(event, value) => onPriceVatChange(value)}
          onWheel={onWheelDisable}
        />
      )}
    </>
  );
}
